import React from 'react';

let Image = (props) => {
  let {url, img, openImg} = props;
  if (img) {
    return (
      <div className="visualOuter" onClick={() => openImg(url + img)}>
        <img src={url + img} alt="Visuales"/>
      </div>
    )
  } else {
    return (
      null
    )
  }

}
export default Image;


// WEBPACK FOOTER //
// ./src/Containers/Image.js